import axios from 'axios'
import config from '@/config/env'

const { API_URL } = config

export const loadCalculatorConfig = (identerprise) => {
  const baseUrl = API_URL + '/pntcalculator/config/customer'
  const url = identerprise ? `${baseUrl}/${identerprise}` : baseUrl
  return axios.get(url)
}

export const getCalculatorResults = (param, identerprise) => {
  const baseUrl = API_URL + '/pntcalculator/result/customer'
  const url = identerprise ? `${baseUrl}/${identerprise}` : baseUrl
  return axios.get(url, {
    params: param,
  })
}

export const loadEnterpriseCalculatorConfig = (identerprise) => {
  const baseUrl = API_URL + '/pntcalculator/config/enterprise'
  const url = identerprise ? `${baseUrl}/${identerprise}` : baseUrl
  return axios.get(url)
}

export const getEnterpriseCalculatorResults = (param, identerprise) => {
  const baseUrl = API_URL + '/pntcalculator/result/enterprise'
  const url = identerprise ? `${baseUrl}/${identerprise}` : baseUrl
  return axios.get(url, {
    params: param,
  })
}

export const getPdf = (budgets, identerprise) => {
  const baseUrl = API_URL + '/pntcalculator/pdf/customer'
  const url = identerprise ? `${baseUrl}/${identerprise}` : baseUrl
  return axios.post(url, budgets)
}

export const getEnterprisePdf = (budgets, identerprise) => {
  const baseUrl = API_URL + '/pntcalculator/pdf/enterprise'
  const url = identerprise ? `${baseUrl}/${identerprise}` : baseUrl
  return axios.post(url, budgets)
}
